import React from "react";
import logo from "../Assets/loading.png";
 import "../Loader/invoice.css"
const Loader = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative flex items-center justify-center">
    
        <div className="absolute h-20 w-20 rounded-full border-4 border-transparent border-t-[#00DE6D]  animate-spin"></div>
     {/* <div className="loader">
      <span>
      <img src={logo} alt="logo" className="h-12 w-12" />
      </span> */}

     {/* </div> */}
        <div className="animate-zoom flex  flex-col items-center justify-center    rounded-full h-16 w-16">
          <img src={logo} alt="logo" className="h-12 w-12" />
          {/* {time &&  <span className="text-white poppins-bold text-xl">{time}%</span>}bg-gradient-to-r from-[#00DE6D] to-[#00ACDC] */}
        </div>

      </div>
    </div>
  );
};   

export default Loader;